export const getObjectValues = object => {
  return Object.keys(object).map(key => {
    return object[key];
  });
};

export function getLocationSearchToObject() {
  const pairs = window.location.search.substring(1).split('&');
  const obj = {};

  pairs.forEach(pair => {
    if (pair !== '' && pair.indexOf('=') > 0) {
      const pairItem = pair.split('=');
      const param = decodeURIComponent(pairItem[0])
        .replace('[][]', '')
        .replace('[]', '');
      const value = decodeURIComponent(pairItem[1]);

      if (obj[param]) {
        obj[param] = `${obj[param]},${value}`;
      } else {
        obj[param] = value;
      }
    }
  });

  return obj;
}
